import {gql} from '@apollo/client';

export default gql`
  mutation completePlacements($input: CompletePlacementsInput!) {
    completePlacements(input: $input) {
      success
    }
  }
`;
